import {
  ParsedSearchableResourceConnectionNew,
  SearchableResourceConnectionNew,
} from "@examspark/types";

/**
 * Parse stringified fields into JSON:
 * - `aggregations`
 */
export const parseSearchResults = (input?: SearchableResourceConnectionNew) => {
  const next: ParsedSearchableResourceConnectionNew = {
    ...input,
    aggregations:
      input?.aggregations && typeof input.aggregations === "string"
        ? JSON.parse(input.aggregations)
        : undefined,
  };

  return next;
};
